import axios from "axios";

const url = `${process.env.AGW_EMPLEO_SERVICES_API_URL}`;
const apikeyServices = process.env.AGW_EMPLEO_SERVICES_API_KEY;
const newTokenizer = process.env.URL_TOKENIZER;

const getToken = async () => {
    const data = await axios.post(
        `${newTokenizer}`,
        {'action': 'getJWT'},
        {
            headers: {
                Apikey: process.env.URL_TOKENIZER_APIKEY,
                Origin: process.env.URL_TOKENIZER_ORIGIN,
                "Content-Type": "application/json",
            },
        }
    );
    return data;
};

const saveForm = async (payload, token) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        return await axios.post(
            `${url}comfama/form-employment/api/v1/form/save-form`,
            payload,
            { headers }, 
        );

    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

const saveFormIdealRoute  = async (payload, token) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        return await axios.post(
            `${url}comfama/enrutador-api/api/v1/ruta-ideal/save-form`,
            payload,
            { headers},
        );
    } catch (error) {
        console.log("error", error);
        throw error;
    }

};

const updateForm = async (idFormAnswer, payload, token) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        return await axios.post(
            `${url}comfama/form-employment/api/v1/form/update-form/${idFormAnswer}`,
            payload,
            { headers },
        );
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

const getFormData = async (formId, token) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        const data = await axios.get(
            `${url}comfama/form-employment/api/v1/form/get-form-data/${formId}`,
            { headers },
        );
        return data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

const getCmdFormData = async (documentId, token) => {

    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        const data = await axios.get(
           `${url}comfama/form-employment/api/v1/form/get-user-cmd-data/${documentId}`,
            { headers },
        );
        return data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

const getUserFormDataByQuestionId = async (token, formId, question, answer) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        const data = await axios.get(
            `${url}comfama/form-employment/api/v1/form/get-user-form-data/${formId}/${question}/${answer}`,
            { headers },
        );

        return data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};


const getCursosData = async (professionalRole, modality, speciality, token) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    try {
        const data = await axios.get(
            `${url}comfama/form-employment/api/v1/form/get-cursos-data/${professionalRole}/${modality}/${speciality}`,
            { headers },
        );
        return data.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
};

const postCursosRegionesData = async ( rqBody, token) =>{
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
    };
    const data = await axios.post(
        `${url}comfama/formaciones-api/api/v1/formaciones/filtered`,
        rqBody,
        { headers },
    )
    return data
}

const saveAttachment = async (token, rqBody) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
        'content-type': 'application/json',
    };
    const data = await axios.post(
        `${url}comfama/upload-sharepoint-employment/api/v1/upload-sharepoint/upload-base64`,
        rqBody,
        { headers },
    );
    return data;
};

const massiveLoadFile = async (token, file) => {

    try{
        // Obtén el valor de "name" desde sessionStorage
        const userName = sessionStorage.getItem("userName");
    
        if (!userName) {
            throw new Error("El valor de 'userName' no está disponible en sessionStorage.");
        }
    
        return await axios.post(
            `${url}comfama/form-employment/api/v1/report/carga-masiva-mentoria-talento`,
            file,
            {
                headers: {
                    Authorization: token.data.data.id_token,
                    apikey: apikeyServices,
                    'Content-Type': `multipart/form-data`,
                    'X-User-Name': userName, // Enviar 'name' como encabezado personalizado
                }
            }
        );
    } catch (error) {
        console.error("Error en massiveLoadFile:", error);
        throw error;
    }
};

const reportsForms = async (token, rqBody) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
        'content-type': 'application/json',
    };
    const data = await axios.post(
        `${url}comfama/form-employment/api/v1/report/orderInfo`,
        rqBody,
        { headers },
    );
    return data;
};

const downloadReport = async (token, rqBody) => {
    const headers = {
        Authorization: token.data.data.id_token,
        apikey: apikeyServices,
        'content-type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Indica que esperas un archivo Excel
    };
    const response = await axios.post(
        `${url}comfama/form-employment/api/v1/report/orderInfo/download`,
        rqBody,
        { headers, responseType: 'blob' }, // responseType 'blob' para manejar archivos binarios
    );
    return response;
};

export { saveForm, getToken, getFormData, updateForm, getCmdFormData, getUserFormDataByQuestionId, getCursosData, postCursosRegionesData, saveAttachment, massiveLoadFile, saveFormIdealRoute, reportsForms, downloadReport};
